import moment from "moment";
import { useState } from "react";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import React from "react";
import SVG from "react-inlinesvg";
import { Typography, createMuiTheme, emphasize, fade } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import NoSsr from "@material-ui/core/NoSsr";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import MenuItem from "@material-ui/core/MenuItem";
import CancelIcon from "@material-ui/icons/Cancel";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useTheme } from "styled-components";
import { StatusFormatter } from "./columnFormatter";
import { DateFormatter } from "./columnFormatter";

export const date =
  localStorage.getItem("formatDate") === null
    ? "MM/DD/YYYY"
    : localStorage.getItem("formatDate");
export const paginationSet =
  localStorage.getItem("pagination") === null
    ? 20
    : parseInt(localStorage.getItem("pagination"));

export const digitGrouping = localStorage.getItem("digitGrouping");
export const coBranding = localStorage.getItem("coBranding");
export const username = localStorage.getItem("username");

console.log(digitGrouping, "digitGrouping");

export const allDate = [
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
];
export const allMonth = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December ",
];

export const sizePerPageList = (totalSize) => [
  {
    text: "10",
    value: 10,
  },
  {
    text: "20",
    value: 20,
  },
  {
    text: "30",
    value: 30,
  },
  {
    text: "40",
    value: 40,
  },
  {
    text: "50",
    value: 50,
  },
];

export const optionsStatusNG = [
  { label: "OK", value: "OK" },
  { label: "NG", value: "NG" },
];

export const iconError = (
  <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />
);

export const iconXRemove = (
  <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-square.svg")} />
);

export const useForceUpdate = () => {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
};

export const formatDate = (stringDate) => {
  if (stringDate === null || stringDate === undefined) {
    return "";
  }
  if (stringDate === "") {
    return "";
  } else {
    let parsedDate = moment(stringDate);
    if (!parsedDate.isValid()) {
      parsedDate = moment(stringDate, 'MM/DD/YYYY hh:mm:ssA');
    }

    return parsedDate.format(date);
  }
};
export const formatDateTime = (stringDate) => {
  if (stringDate === null) {
    return "";
  } else if (stringDate === "") {
    return "";
  } else {
    let parsedDate = moment(stringDate);
    if (!parsedDate.isValid()) {
      parsedDate = moment(stringDate, 'MM/DD/YYYY hh:mm:ssA');
    }

    return parsedDate.format("DD MMMM YYYY - HH:mm");
  }
};

const useCommaSeparator = digitGrouping === "999,999.00" ? true : false;

export const formatQuantity = (cellContent) => {
  const separator = useCommaSeparator ? "," : ".";

  if (separator) {
    const formattedNumber = new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0, // 2 digit desimal
    }).format(cellContent);

    return formattedNumber.replace(/\./g, separator);
  } else {
    const formattedNumber = new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0, // 2 digit desimal
    }).format(cellContent);

    return formattedNumber.replace(/\,/g, separator);
  }
};

export const getValueOptions = (value, options) => {
  const return_value = options.filter((val) => value === val.value);
  return return_value;
};

export const getValueType = (value, options) => {
  const return_value = options.filter((val) => value === val.value);
  return return_value;
};

export const checkMenu = (menu, allowedMenu) => {
  return menu.some((e) => allowedMenu.includes(e));
};

export const checkPermision = (permission, allowedPermission) => {
  return permission.some((e) => allowedPermission.includes(e));
};

export const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiInputBase: {
      input: {
        padding: "23px 12px 10px",
      },
    },
    MuiInputLabel: {
      filled: {
        zIndex: 1,
        transform: "translate(12px, 10px) scale(0.75) !important",
        pointerEvents: "none",
      },
      "filled.MuiInputLabel-sizeSmall": {
        transform: "translate(12px, 10px) scale(0.75) !important",
        pointerEvents: "none",
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

const currentDate = new Date();
const year = currentDate.getFullYear();
const month = String(currentDate.getMonth() + 1).padStart(2, "0");
const day = String(currentDate.getDate()).padStart(2, "0");

export const dateDefault = `${year}-${month}-${day}`;
export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: "10px !important",
  },
  labelFilledShrinkMarginDense: {
    transform: "translate(12px, 10px) scale(0.75)",
  },
}));

export const useStylesReddit = makeStyles((theme) => ({
  root: {
    fontSize: "12px",
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF !important",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },

    "&.Mui-disabled": {
      color: "black",
      cursor: "default",
    },
  },
  focused: {},
  "& .MuiInputLabel-root": {
    transform: "translate(12px, 10px) scale(1)",
    fontSize: "12px !important  ",
    backgroundColor: "#FFFFFF !important",
  },
  "& .MuiFilledInput-root": {
    backgroundColor: "#FFFFFF !important",
  },
  "&.Mui-disabled": {
    color: "black",
    cursor: "default",
  },
}));

export const customStyles = makeStyles((theme) => ({
  labelFilledShrinkMarginDense: {
    transform: "translate(12px, 7px) scale(0.75)",
  },
  labelFilledShrinkMarginDenseSmall: {
    transform: "translate(12px, 7px) scale(0.75)",
  },
  "& .MuiInputLabel-root": {
    transform: "translate(12px, 10px) scale(1)",
    fontSize: "12px",
  },
  "&.Mui-disabled": {
    color: "black",
    cursor: "default",
  },
}));

export const useStylesSelect = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: "flex",
    padding: 0,
    height: "auto",
  },
  valueContainer: {
    display: "flex",
    flexWrap: "wrap",
    flex: 1,
    alignItems: "center",
    overflow: "hidden",
  },
  chip: {
    margin: theme.spacing(0.5, 0.25),
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === "light"
        ? theme.palette.grey[300]
        : theme.palette.grey[700],
      0.08
    ),
  },
  noOptionsMessage: {
    padding: theme.spacing(1, 2),
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: "absolute",
    left: 2,
    bottom: 6,
    fontSize: 16,
  },
  paper: {
    position: "absolute",
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
}));

export const selectStyles = {
  input: (base) => ({
    ...base,
    // color: "",
    "& input": {
      font: "inherit",
    },
  }),
  control: (provided, state) => ({
    ...provided,
    zIndex: 9999, // Nilai z-index yang diinginkan
  }),
};

function NoOptionsMessage(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

NoOptionsMessage.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
};

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />;
}

inputComponent.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

function Control(props) {
  const {
    children,
    innerProps,
    innerRef,
    selectProps: { classes, TextFieldProps },
  } = props;

  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: classes.input,
          ref: innerRef,
          children,
          ...innerProps,
        },
      }}
      {...TextFieldProps}
    />
  );
}

Control.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  selectProps: PropTypes.object.isRequired,
};

function Option(props) {
  return (
    <MenuItem
      ref={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  );
}

Option.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  isFocused: PropTypes.bool,
  isSelected: PropTypes.bool,
};

function Placeholder(props) {
  return (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

Placeholder.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
};

function SingleValue(props) {
  return (
    <Typography
      className={props.selectProps.classes.singleValue}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );
}

SingleValue.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object.isRequired,
};

function ValueContainer(props) {
  return (
    <div className={props.selectProps.classes.valueContainer}>
      {props.children}
    </div>
  );
}

ValueContainer.propTypes = {
  children: PropTypes.node,
  selectProps: PropTypes.object.isRequired,
};

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={clsx(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused,
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  );
}

MultiValue.propTypes = {
  children: PropTypes.node,
  isFocused: PropTypes.bool,
  removeProps: PropTypes.object.isRequired,
  selectProps: PropTypes.object.isRequired,
};

function Menu(props) {
  return (
    <Paper
      square
      className={props.selectProps.classes.paper}
      {...props.innerProps}
    >
      {props.children}
    </Paper>
  );
}

Menu.propTypes = {
  children: PropTypes.node,
  innerProps: PropTypes.object,
  selectProps: PropTypes.object,
};

export const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

export const columnsComplate = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },
  {
    text: "Master Code",
    dataField: "master_code",
    sort: true,
  },
  {
    text: "Model Code",
    dataField: "model_code",
    sort: true,
  },
  {
    text: "Color Code",
    dataField: "color_code",
    sort: true,
  },
  {
    text: "Require Acc. Installation",
    dataField: "inbound_rule",
    sort: true,
    formatter: StatusFormatter,
  },
  {
    text: "Production Date",
    dataField: "production_date_uploaded",
    sort: true,
    formatter: DateFormatter
  },
  {
    text: "Model Year",
    dataField: "model_year",
    sort: true,
  },
  {
    text: "Engine No.",
    dataField: "engine_no",
    sort: true,
  },
  {
    text: "Key No.",
    dataField: "key_no",
    sort: true,
  },
  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks",
    dataField: "remark_validate",
    sort: true,
  },
];

export const columnsExportExcel = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },
  {
    text: "Master Code",
    dataField: "master_code",
    sort: true,
  },
  {
    text: "Model Code",
    dataField: "model_code",
    sort: true,
  },
  {
    text: "Color Code",
    dataField: "color_code",
    sort: true,
  },
  {
    text: "Require Acc. Installation",
    dataField: "inbound_rule",
    sort: true,
    formatter: StatusFormatter,
  },
  {
    text: "Production Date",
    dataField: "production_date_uploaded",
    sort: true,
    formatter: DateFormatter
  },
  {
    text: "Model Year",
    dataField: "model_year",
    sort: true,
  },
  {
    text: "Engine No.",
    dataField: "engine_no",
    sort: true,
  },
  {
    text: "Key No.",
    dataField: "key_no",
    sort: true,
  },
  {
    text: "Upload Status",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Validation Message",
    dataField: "remark_validate",
    sort: true,
  }
];

export const columnsUploaded = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },
  {
    text: "Master Code",
    dataField: "master_code",
    sort: true,
  },
  {
    text: "Model Code",
    dataField: "model_code",
    sort: true,
  },
  {
    text: "Color Code",
    dataField: "color_code",
    sort: true,
  },
  {
    text: "Require Acc. Installation",
    dataField: "inbound_rule",
    sort: true,
    formatter: StatusFormatter,
  },
  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks",
    dataField: "remark_validate",
    sort: true,
  },
];

export const columnsUploadRci = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },
  {
    text: "Require Acc. Installation",
    dataField: "inbound_rule",
    sort: true,
    formatter: StatusFormatter,
  },
  {
    text: "Inspection Result",
    dataField: "inspection_result",
    sort: true,
  },
  {
    text: "Engine No",
    dataField: "engine_no",
    sort: true,
  },
  {
    text: "Key No",
    dataField: "key_no",
    sort: true,
  },
  {
    text: "Mileage",
    dataField: "mileage",
    sort: true,
  },
  {
    text: "Remark",
    dataField: "remarks",
    sort: true,
  },

  {
    text: "RCI Date",
    dataField: "rci_date",
    sort: true,
    formatter: formatDate,
  },

  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];
export const columnsUploadPDIIN = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },

  {
    text: "Remark",
    dataField: "remarks",
    sort: true,
  },

  {
    text: "PDI-In Date",
    dataField: "pdi_in_date",
    sort: true,
    formatter: formatDate,
  },

  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];
export const columnsUploadPDIOUT = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },

  {
    text: "Inspection Result",
    dataField: "inspection_result",
    sort: true,
  },
  {
    text: "Remarks",
    dataField: "remarks",
    sort: true,
  },
  {
    text: "PDI-Out Date",
    dataField: "pdi_out_date",
    sort: true,
    formatter: formatDate,
  },
  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];
export const columnsUploadTSA = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },

  {
    text: "Location",
    dataField: "location_name",
    sort: true,
  },

  {
    text: "Storage Date",
    dataField: "storage_date",
    sort: true,
    formatter: formatDate,
  },

  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];

export const columnsView = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,

    headerAlign: "center",
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
    headerAlign: "center",
  },
  {
    text: "Maintenance Date",
    dataField: "maintenance_date",
    sort: true,
    headerAlign: "center",
    formatter: formatDate,
  },

  {
    text: "Remarks",
    dataField: "remarks",
    sort: true,
    headerAlign: "center",
  },

  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];

export const columnsViewInspection = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,

    headerAlign: "center",
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
    headerAlign: "center",
  },
  {
    text: "Inspection Date",
    dataField: "inspection_date",
    sort: true,
    headerAlign: "center",
    formatter: formatDate,
  },

  {
    text: "Inspection Result",
    dataField: "inspection_result",
    sort: true,
    headerAlign: "center",
  },

  {
    text: "Remarks",
    dataField: "remarks",
    sort: true,
    headerAlign: "center",
  },

  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];


export const columnsUploadRePDIOUT = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },
  {
    text: "Pdi Out Date",
    dataField: "pdi_out_date",
    sort: true,
    formatter: formatDate,
  },
  {
    text: "Inspection Result",
    dataField: "inspection_result",
    sort: true,
  },
  {
    text: "Remarks",
    dataField: "remarks",
    sort: true,
  },
  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];

export const columnsUploadRePDIOUTNotC = [
  {
    text: "VIN",
    dataField: "vin",
    sort: true,
  },
  {
    text: "VON",
    dataField: "von",
    sort: true,
  },
  {
    text: "Pdi Out Date",
    dataField: "pdi_out_date",
    sort: true,
    formatter: formatDate,
  },
  {
    text: "Inspection Result",
    dataField: "inspection_result",
    sort: true,
  },
  {
    text: "Remarks",
    dataField: "remarks",
    sort: true,
  },
  {
    text: "Validate",
    dataField: "status_validate",
    sort: true,
  },
  {
    text: "Remarks Validate",
    dataField: "remark_validate",
    sort: true,
  },
];

export const clearValues = (data) => {
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      data[key].value = "";
    }
  }
};

export const optionsStatus = [
  {
    label: "Confirmed",
    value: "Confirmed",
  },
  {
    label: "Initiated",
    value: "Initiated",
  },
  {
    label: "Canceled",
    value: "Canceled",
  },
];

export const optionsRFS = [
  {
    label: "Yes",
    value: "Y",
  },
  {
    label: "No",
    value: "N",
  },
  
];

export const parseDateString = (str) => {
  return new Date(str);
};

export const isDateFormat = (str) => {
  const dateFormatRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return dateFormatRegex.test(str);
};

export const validatePost = (formValues, setFormValues) => {
  let isValid = true;

  const formFields = Object.keys(formValues);
  let newFormValues = { ...formValues };

  for (let index = 0; index < formFields.length; index++) {
    const currentField = formFields[index];
    const currentValue = formValues[currentField].value;
    const required = formValues[currentField].required;

    if (currentValue === "" && required === "Y") {
      newFormValues = {
        ...newFormValues,
        [currentField]: {
          ...newFormValues[currentField],
          error: true,
        },
      };
      isValid = false;
    } else if (currentValue === null && required === "Y") {
      newFormValues = {
        ...newFormValues,
        [currentField]: {
          ...newFormValues[currentField],
          error: true,
        },
      };
      isValid = false;
    } else {
      newFormValues = {
        ...newFormValues,
        [currentField]: {
          ...newFormValues[currentField],
          error: false,
        },
      };
    }
  }

  setFormValues(newFormValues);

  console.log(isValid, "isValid");
  return isValid;
};

export function validateDateFields(formValues, dateFields) {
  for (const field of dateFields) {
    const startField = `${field}_start`;
    const endField = `${field}_end`;
    const startValue = formValues[startField].value;
    const endValue = formValues[endField].value;

    if ((startValue && !endValue) || (endValue && !startValue)) {
      return "Please fill in both date filters: From Date and Until Date.";
    }
  }
  return null; // Validasi berhasil
}
